import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { IoIosInformationCircle } from 'react-icons/io';
import { useHistory } from 'react-router';
import { FaCog } from 'react-icons/fa';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

const PublishNotAvailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px;
  gap: 8px;
  width: 592px;
  background: ${({ theme }) => theme.colors.danger[5]};
  border-radius: 5px;
  margin-bottom: 32px;
`;

const IconContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

const MessageTextWrapper = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral[100]};
`;

export const PublishNotAvailable = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const history = useHistory();

  const navigateToSocialProfileSettings = () => {
    history.push('/profile/social-profiles');
  };

  return (
    <PublishNotAvailableContainer>
      <MessageContainer>
        <IconContainer>
          <IoIosInformationCircle
            size='20'
            color={colors.danger[60]}
          ></IoIosInformationCircle>
        </IconContainer>
        <MessageTextWrapper>
          {t(
            'In order to publish your video natively to your social media profiles (Facebook, YouTube, LinkedIn) you have to'
          )}{' '}
          <u>{t('connect your social media profiles.')}</u>
        </MessageTextWrapper>
      </MessageContainer>
      <Button
        text={t('Open Social Profiles Settings')}
        onClick={navigateToSocialProfileSettings}
        icon={<FaCog color={colors.white[100]} />}
      />
    </PublishNotAvailableContainer>
  );
};
